import {session} from "@/utils/session"

export default {
    namespaced: true,
    state: {
        token: session.getValue('token'),
        note: session.getValue('nota')
    },

    getters: {
        getNote: (state) => {
            return state.note;
        }
    },

    mutations: {
        SET_NOTE_AUTH(state) {
            state.token = session.getValue('token')
            state.note = session.getValue('nota')
        }
    },

    actions: {

        loginAuth: async ({commit, rootState}, data) => {
            await rootState.init.http_common.post('/login', JSON.stringify(data)).then((response) => {
                session.set(response.data.result);
                commit('SET_NOTE_AUTH');
            })
        },


        clearAuth({commit}) {
            session.remove();
            commit('SET_NOTE_AUTH');

        }

    }

}
